import { Component } from '@angular/core';
import { ExtraFieldType } from '../extra-field-type';

@Component({
  selector: 'formly-field-custom',
  template: `
    <ndc-dynamic [ndcDynamicComponent]="to.componentName" [ndcDynamicInputs]="to.inputs" [ndcDynamicOutputs]="to.outputs"></ndc-dynamic>
	`
})
export class FormlyFieldCustomComponent extends ExtraFieldType { }